import React from "react";
import { FaPhone, FaEnvelope, FaTimes, FaGlobe } from "react-icons/fa";
import PageModal from "../../Dashboard/Components/PageModal";

function ContactDetailsModal({ contact, onClose }) {
  const getContactIcon = (type) => {
    switch (type) {
      case "mobile":
      case "landline":
      case "hotline":
        return <FaPhone className="text-[#363062] w-5 h-5" />;
      case "email":
        return <FaEnvelope className="text-[#363062] w-5 h-5" />;
      case "website":
        return <FaGlobe className="text-[#363062] w-5 h-5" />;
      default:
        return <FaPhone className="text-[#363062] w-5 h-5" />;
    }
  };

  const getContactLink = (type, detail) => {
    switch (type) {
      case "mobile":
      case "landline":
      case "hotline":
        return `tel:${detail}`;
      case "email":
        return `mailto:${detail}`;
      case "website":
        return detail.startsWith("http") ? detail : `https://${detail}`;
      default:
        return `tel:${detail}`;
    }
  };

  return (
    <PageModal>
      <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full mx-4 my-8 p-6">
        <div className="flex justify-between items-start mb-6">
          <div className="flex flex-col items-center gap-6">
            <div className="w-24 h-24 rounded-full bg-[#363062]/10 flex items-center justify-center overflow-hidden">
              {contact.photoUrl ? (
                <img
                  src={contact.photoUrl}
                  alt={contact.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-3xl font-semibold text-[#363062]">
                  {contact.name.charAt(0)}
                </span>
              )}
            </div>
            <h2 className="text-lg font-semibold text-[#363062]">
              {contact.name}
            </h2>
            <p className="text-sm text-gray-600">{contact.title}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-[#363062] transition-colors"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-6">
          {/* Primary Contact Details */}
          {contact.contactNumber && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#363062]/10 flex items-center justify-center">
                <FaPhone className="text-[#363062] w-5 h-5" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Phone Number</p>
                <a
                  href={`tel:${contact.contactNumber}`}
                  className="text-[#363062] hover:text-[#363062]/80 transition-colors"
                >
                  {contact.contactNumber}
                </a>
              </div>
            </div>
          )}

          {contact.email && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#363062]/10 flex items-center justify-center">
                <FaEnvelope className="text-[#363062] w-5 h-5" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Email Address</p>
                <a
                  href={`mailto:${contact.email}`}
                  className="text-[#363062] hover:text-[#363062]/80 transition-colors"
                >
                  {contact.email}
                </a>
              </div>
            </div>
          )}

          {/* Additional Contact Details */}
          {contact.additionalContacts &&
            contact.additionalContacts.length > 0 && (
              <div className="mt-6">
                <h4 className="text-sm font-medium text-[#363062] mb-4">
                  Additional Contact Details
                </h4>
                <div className="space-y-4">
                  {contact.additionalContacts.map((contact, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg bg-[#363062]/10 flex items-center justify-center">
                        {getContactIcon(contact.type)}
                      </div>
                      <div>
                        <p className="text-sm text-gray-500 capitalize">
                          {contact.type}
                        </p>
                        <a
                          href={getContactLink(contact.type, contact.detail)}
                          className="text-[#363062] hover:text-[#363062]/80 transition-colors"
                          target={
                            contact.type === "website" ? "_blank" : undefined
                          }
                          rel={
                            contact.type === "website"
                              ? "noopener noreferrer"
                              : undefined
                          }
                        >
                          {contact.detail}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {contact.contactNumber && (
            <a
              href={`tel:${contact.contactNumber}`}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#363062] rounded-lg hover:bg-[#363062]/90 transition-colors"
            >
              <FaPhone className="w-4 h-4" />
              Call
            </a>
          )}
          {contact.email && (
            <a
              href={`mailto:${contact.email}`}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#363062] rounded-lg hover:bg-[#363062]/90 transition-colors"
            >
              <FaEnvelope className="w-4 h-4" />
              Email
            </a>
          )}
        </div>
      </div>
    </PageModal>
  );
}

export default ContactDetailsModal;
